import { addCommas } from './helpers';
import EmailSection from './EmailSection';

const EstimatedCosts = ({
  formData,
  nyTransferTaxRate,
  nyTransferTaxCost,
  nyStateTransferTaxRate,
  nyStateTransferTaxCost,
  attorneyFeePercent,
  isFee, setIsFee,
  isCost,setIsCost,
  setFormData,
  resetHandler,
  userParams, 
  setUserParams,
}) => {

    return(
        <div id='right' className="col-12 col-md-10 col-lg-6">
            <h4>Estimated Closing Costs</h4>
            <div className="row ">

              <div className="col-lg-8 col-md-6 col-6">
                
                <div className="title-cost"><span className="indicator1"></span>Mansion Tax</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">${addCommas((formData.purchasePrice * isFee.mansionTax / 100).toFixed(0))}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{isFee.mansionTax}%</div>
              </div>
              <div className='w-100'></div>

              {/* Title Insurance - Owner's Policy Premium */}
              {(formData.propertyType !== '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>Title Insurance - Owner's Policy Premium</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">${addCommas((formData.purchasePrice * isFee.titleInsurance / 100).toFixed(0))}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{isFee.titleInsurance}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>Buyer's Attorney Fee</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="numbers">${addCommas(formData.bayerAttorneyFee)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{attorneyFeePercent}%</div>
              </div>
              <div className='w-100'></div>

              {/* Move-In Deposit */}
              {(formData.propertyType !== '3') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Move-In Deposit</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                  <div className="">${formData.moveInDeposit}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.moveInDeposit * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              {/* Title Search - Other Charges */}
              {(formData.propertyType !== '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Title Search - Other Charges</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                  <div className="">${formData.titleSearch}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.titleSearch * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              {/* Board Application Fees */}
              {(formData.propertyType !== '3') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Board Application Fees</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                  <div className="">${formData.boardApplicationFee}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.boardApplicationFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}
                
              {/* Move-In Fee */}
              {(formData.propertyType !== '3') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Move-In Fee</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                  <div className="">${formData.moveInFee}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.moveInFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Survey Fees</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.surveyFee}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.surveyFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>

              {(formData.propertyType !== '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Title Search - Endorsements
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.titleSearchEndorsement}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.titleSearchEndorsement * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              {/* Deed Recording Fees */}
              {(formData.propertyType !== '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Deed Recording Fees
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.deedRecordingFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.deedRecordingFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              {/* Lien Search Fee */}
              {formData.propertyType === '2' && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Lien Search Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.lienSearchFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.lienSearchFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Credit Check
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.creditCheck}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.creditCheck * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>

              {/* ****** Financing Related Costs ***** */}
              {(formData.amountFinancedPrecent !== '1') && 
              <>
              <h4 className="mt-2">Financing Related Costs</h4>

              {/* Mortgage Recording Tax */}
              {(formData.propertyType !== '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>Mortgage Recording Tax
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="numbers">${addCommas((formData.mortgageRecordingTax * formData.purchasePrice / 100).toFixed(0))}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                  <div className="numbers">{(formData.mortgageRecordingTax)}%</div>
              </div>
              <div className='w-100'></div>
              

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Title Insurance - Mortgage Policy Premium
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${addCommas((formData.mortgagePolicyPremium * formData.purchasePrice / 100).toFixed(0))} 
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                  <div className="numbers">{formData.mortgagePolicyPremium}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Bank's Attorney Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.bankAttorneyFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.bankAttorneyFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Loan Application Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.loanApplicationFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.loanApplicationFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Appraisal Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.appraisalFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.appraisalFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>

              {/* Mortgage Recording Fee */}
              {(formData.propertyType !== '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Mortgage Recording Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.mortgageRecordingFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.mortgageRecordingFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              {(formData.propertyType === '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Recognition Agreement Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.recognitionAgreementFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.recognitionAgreementFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              {/* UCC-1 Filing Fee */}
              {(formData.propertyType === '2') && <>
              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>UCC-1 Filing Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${formData.ucc1FilingFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.ucc1FilingFee * 100 / formData.purchasePrice).toFixed(3)}%</div>
              </div>
              <div className='w-100'></div>
              </>}

              </>}


              {/* New Construction Related Costs */}
              {formData.newConstruction && 
              <>
              <h4 className='mt-2'>New Construction Related Costs</h4>

              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>NYC Transfer Tax</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">${addCommas(nyTransferTaxCost)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{nyTransferTaxRate}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator1"></span>NY State Transfer Tax</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${addCommas(nyStateTransferTaxCost)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{nyStateTransferTaxRate}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Sponsor's Attorney Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${addCommas(formData.sponsorAttorneyFee)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(formData.sponsorAttorneyFee * 100 / formData.purchasePrice).toFixed(2)}%</div>
              </div>
              <div className='w-100'></div>
              </>}     

              <div className="col-12">
                <div className="horizontal-line"></div>
              </div>
             
              <div className="col-lg-8 col-md-6 col-6 top-sel-cost">
                <div className="">Total
              </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 top-sel-cost">
                <div className="">${addCommas(isCost.toFixed(0))}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right top-sel-cost">
                <div className="">{(isCost * 100 /formData.purchasePrice).toFixed(2)}%</div>
              </div>
              <div className='w-100'></div>

              <span id="tabletEmail">
                <EmailSection 
                  formData={formData}
                  setFormData={setFormData}
                  resetHandler={resetHandler}
                  userParams={userParams} 
                  setUserParams={setUserParams}
                />
              </span>

            </div>
            {/* <div className='text-center'>
              <button id="save-btn" type="button" class="btn btn-secondary btn-lg">Detailed Market Valuation</button>
            </div> */}
        </div>
    );
}

export default EstimatedCosts;